import { useAppSelector } from 'shared';

export const useCartPageState = () => useAppSelector((store) => store.cartPage);
